import actions from "./actions";
import { Map } from "immutable";
import reducerUtils from "../reducerUtils";

const initState = Map({ accessToken: null, loading: false, error: null });

export default function infiAuthReducer(state = initState, action) {
  switch (action.type) {
    case actions.INFI_LOGIN_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.INFI_LOGIN_SUCCESS:
      return state.merge({ accessToken: action.accessToken, loading: false });
    case actions.INFI_LOGIN_ERROR:
      return state.merge({ loading: false, error: action.error });
    case actions.INFI_LOGOUT:
      return initState;
    case actions.INFI_SIGN_UP_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.INFI_SIGN_UP_SUCCESS:
      return state.merge({ accessToken: action.accessToken, loading: false });
    case actions.INFI_SIGN_UP_ERROR:
      return state.merge({ loading: false, error: action.error });
    case actions.INFI_AUTH_CLEAR_STATUS:
      return state.merge({ loading: false, error: null });
    default:
      return state;
  }
}
